import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../core/auth/authSlice";
import { PostApiRoutes } from "../../../../shared/api-routes/post/post.api-routes";
import { User } from "../../../../shared/models";
import http from "../../../../shared/utils/http";
import UserCard, {
	UserPreviewInfo,
} from "../../../essentials/user-card/UserCard";
import "./LikeModal.scss";

export interface LikeModalProps {
	post_id: string;
	comment_id?: string;
}

export interface Likes {
	liker: UserPreviewInfo;
}

const LikeModal: React.FC<LikeModalProps> = ({ post_id, comment_id }) => {
	const [likes, setLikes] = useState<Likes[]>([]);

	const { userId } = useSelector(selectUser) as User;
	useEffect(() => {
		if (comment_id) {
			http
				.get(PostApiRoutes.GET_COMMENT_LIKES(post_id, comment_id))
				.then((res) => {
					setLikes(res);
				});
		}
	}, [post_id]);

	return (
		<div className="like-modal">
			{likes.map((like, index) => {
				return (
					<div key={index}>
						{index > 0 ? <div className="divider" /> : ""}
						<UserCard
							action="follow"
							className="liker-card"
							userInfo={like.liker}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default LikeModal;
